import React from 'react'

import { ButtonClean, Icon } from '@fourthwall/components'
import { NewWindowIcon } from '@fourthwall/icons'

import * as S from './GoogleAnalyticsReportBottomContent.styled'

type GoogleAnalyticsReportBottomContentProps = {
  href?: string
}

export const GoogleAnalyticsReportBottomContent = ({
  href,
}: GoogleAnalyticsReportBottomContentProps) => {
  return (
    <S.Container>
      This data comes from Google Analytics and is gathered from the moment you added the
      integration.{` `}
      {href && (
        <ButtonClean
          appearance="secondary"
          label={
            <S.Label>
              View in Google Analytics
              <Icon component={NewWindowIcon} height={10} />
            </S.Label>
          }
          href={href}
          target="_blank"
        />
      )}
    </S.Container>
  )
}
